import { render, staticRenderFns } from "./SelectActivities.vue?vue&type=template&id=b3003ca6"
import script from "./SelectActivities.vue?vue&type=script&lang=js"
export * from "./SelectActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports